import {ClientReportSubmitInput} from "../domain";
import {CommentsInput} from "../client-report/CommentsInput";
import {useFormContext} from "react-hook-form";
import React from "react";
import {TextInput} from "./TextInput";

type Props = {
    disabled: boolean;
}

export function ShortAddendumInput({disabled}: Props) {
    const methods = useFormContext<ClientReportSubmitInput>();
    const registeredNameAndTitle = methods.register('nameAndTitle', {
        required: {
            value: true,
            message: 'Required'
        },
        validate: {notBlank}
    });
    const registeredLicenseNumber = methods.register('licenseNumber', {
        required: {
            value: true,
            message: 'Required'
        },
        validate: {notBlank}
    });

    return (
        <>
            <CommentsInput
                label={'Clinical Rationale'}
                fieldName={'clinicalRationale'}
                validate={notBlank}
                required
                sending={disabled}
            />

            <TextInput
                label='Name and Title'
                registered={registeredNameAndTitle}
                disabled={disabled}
                error={methods.formState.errors['nameAndTitle']?.message ?? undefined}
            />

            <TextInput
                label='License/Certificate #'
                registered={registeredLicenseNumber}
                disabled={disabled}
                error={methods.formState.errors['licenseNumber']?.message ?? undefined}
            />
        </>
    )
}

const whitespaceRegex = /^\s*$/;

const notBlank = (v: string) => {
    return !whitespaceRegex.test(v || '') || 'Need at least 1 character';
};

